<template>
    <div v-if="creatorVideo.previewUrl || creatorVideo.thumbnailUrl" class="video-card">
        <div class="video-card-preview">
            <img
                :src="creatorVideo.previewUrl || creatorVideo.thumbnailUrl"
                class="video-card-img"
            />
            <div v-if="formattedDuration" class="video-card-duration">
                {{ formattedDuration }}
            </div>
        </div>
        <div class="video-card-info">
            <div
                v-if="creatorVideo.message"
                class="video-card-message text-truncate"
            >
                {{ creatorVideo.message }}
            </div>
            <div class="video-card-date">
                {{ creatorVideo.publishDateTerse }}
            </div>
        </div>
    </div>
</template>

<style scoped>
.video-card {
    cursor: pointer;
}

.video-card-preview {
    position: relative;
    aspect-ratio: 9 / 16;
    overflow: hidden;
    border-radius: 8px;
    background: #1a1a1a;
}

.video-card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.video-card-duration {
    position: absolute;
    bottom: 6px;
    right: 6px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    font-size: 0.7rem;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    letter-spacing: 0.02em;
}

.video-card-info {
    padding: 6px 2px;
}

.video-card-message {
    font-size: 0.8rem;
    color: #e2e8f0;
    line-height: 1.3;
}

.video-card-date {
    font-size: 0.7rem;
    color: #94a3b8;
    margin-top: 2px;
}
</style>

<script>
export default {
    computed: {
        formattedDuration() {
            if (!this.creatorVideo.duration) return null;
            const d = this.creatorVideo.duration;
            const min = Math.floor(d / 60);
            const sec = d % 60;
            return `${min}:${String(sec).padStart(2, "0")}`;
        },
    },
    props: ["creatorVideo"],
};
</script>
